/** @jsxImportSource @emotion/react */
import { Button, DialogActions, DialogContent, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { Il8nContext } from '../../Helper/i18n'
import { useContext } from 'react';
import Popup, { PopupTitle } from '../../Components/CustomPopup'

export default function PopupBlockerAlert(props) {
  const theme = useTheme()
  const localeText = useContext(Il8nContext)


  return (
    <Popup
      open={props.openPopupBlockerAlert}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          props.handlePopupBlockerAlertDialog(event);
        }
      }}
      fullWidth={true}
      maxWidth={'sm'}
      disableEscapeKeyDown
    >
      <PopupTitle dontShowCloseIcon backgroundColor={"#f54040"} customCSS={{color:"white", textAlign: "center"}} >
        <Typography display="inline" variant={"body1"} >{localeText?.finalSubmitPopupBlocked}</Typography>
      </PopupTitle>
      <DialogContent css={{padding:"30px"}}>
        <Typography css={{paddingTop:"30px"}}>
          {localeText?.finalSubmitPopupBlockerOff}
        </Typography>
        {props.showPopupEnablingGuide &&
          <Grid>
            <p>
              <i css={{ fontWeight: "bold", paddingBottom:"20px" }}>{localeText?.finalSubmitChromeBrowser}</i><br />
              {localeText?.finalSubmitClick}<br />
              {localeText?.finalSubmitPrivacy}<br />
              {localeText?.finalSubmitRedirects}<br />
              {localeText?.finalSubmitAllow}
            </p>
          </Grid>}
        <DialogActions>
          <Button color="error" variant="outlined" onClick={props.handlePopupDialogOkayClick}>
            {localeText?.finalSubmitAllowPopupsProceed}
          </Button>
        </DialogActions>
      </DialogContent>
    </Popup>
  )
}
